import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ConfigModule, I18nModule } from '@spartacus/core';
import { ClinicalFluadSecondComponent } from './clinical-fluad-second/clinical-fluad-second.component';
import { ClinicalFluadThirdComponent } from './clinical-fluad-third/clinical-fluad-third.component';
import { ClinicalFluadFirstComponent } from './clinical-fluad-first/clinical-fluad-first.component';
import { TopnavigationComponent } from './topnavigation/topnavigation.component';
import { MatTabsModule } from '@angular/material/tabs';
import { FluadchoosenowComponent } from './fluadchoosenow/fluadchoosenow.component';
import { ClinicalTopImageComponent } from './clinical-top-image/clinical-top-image.component';
import { RouterModule } from '@angular/router';





@NgModule({
  declarations: [
       ClinicalFluadSecondComponent,
       ClinicalFluadThirdComponent,
       ClinicalFluadFirstComponent,
       TopnavigationComponent,
       FluadchoosenowComponent,
       ClinicalTopImageComponent,
  ],
  imports: [
    CommonModule,
    MatTabsModule,
    I18nModule,
    RouterModule,
    ConfigModule.withConfig({
      cmsComponents:{
        SeqirusProductNavigationBanner:{
          component:TopnavigationComponent 
        },
        SeqirusBoostedImmuneComponent:{
          component: ClinicalFluadFirstComponent
        },
        SeqirusDemonstratedComponent:{
          component: ClinicalFluadSecondComponent
        },
        SeqirusMillionDosesComponent:{
          component: ClinicalFluadThirdComponent
        },
        SeqirusProductViewComponent:{
          component:FluadchoosenowComponent 
        },
        SeqirusProductImageBannerComponent:{
          component: ClinicalTopImageComponent
        }
      }
    })
  ]
})
export class ClinicaldataFluadModule { }
